import { supportsDataView } from "./_setup.js";
import hasObjectTag from "./_hasObjectTag.js";
export var hasStringTagBug = supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8))), isIE11 = typeof Map !== "undefined" && hasObjectTag(/* @__PURE__ */ new Map());
